/** Shared arc geometry helpers for radial selectors */

// Core radii shared across all radial arc components
export const INNER_R = 90
export const OUTER_R = 160
export const MID_R = (INNER_R + OUTER_R) / 2

export function polarToCartesian(cx: number, cy: number, r: number, angleDeg: number) {
  const rad = ((angleDeg - 90) * Math.PI) / 180
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) }
}

/** Arc band path with rounded (semicircle) end caps */
export function describeArcWithCaps(
  cx: number,
  cy: number,
  innerR: number,
  outerR: number,
  startDeg: number,
  endDeg: number
) {
  const capR = (outerR - innerR) / 2
  const sOuter = polarToCartesian(cx, cy, outerR, startDeg)
  const eOuter = polarToCartesian(cx, cy, outerR, endDeg)
  const sInner = polarToCartesian(cx, cy, innerR, startDeg)
  const eInner = polarToCartesian(cx, cy, innerR, endDeg)
  const largeArc = endDeg - startDeg > 180 ? 1 : 0

  return [
    `M ${sOuter.x} ${sOuter.y}`,
    `A ${outerR} ${outerR} 0 ${largeArc} 1 ${eOuter.x} ${eOuter.y}`,
    `A ${capR} ${capR} 0 0 1 ${eInner.x} ${eInner.y}`,
    `A ${innerR} ${innerR} 0 ${largeArc} 0 ${sInner.x} ${sInner.y}`,
    `A ${capR} ${capR} 0 0 1 ${sOuter.x} ${sOuter.y}`,
    "Z"
  ].join(" ")
}

/** Simple stroke arc path along a given radius */
export function describeStrokeArc(cx: number, cy: number, r: number, startDeg: number, endDeg: number) {
  const s = polarToCartesian(cx, cy, r, startDeg)
  const e = polarToCartesian(cx, cy, r, endDeg)
  const largeArc = endDeg - startDeg > 180 ? 1 : 0
  return `M ${s.x} ${s.y} A ${r} ${r} 0 ${largeArc} 1 ${e.x} ${e.y}`
}
